import moment from 'moment';

const parseIsoDuration = (isoString) => {
  return moment.duration(isoString).asMilliseconds();
};

export default parseIsoDuration;
